import requestHandler from '../requestHandler';

const getAllCountries = language =>
  requestHandler.get(`/api/v1/countries/all`, { language });

export default getAllCountries;
